<template>
    <div class="z-not-found">
        <div class="z-not-found__image" v-if="!hideImage">
            <template v-if="!!slots.image">
                <slot name="image"></slot>
            </template>
            <z-image v-else :src="image" width="120" height="120"></z-image>
        </div>
        <div class="z-not-found__description">
            <template v-if="!!slots.description">
                <slot name="description" v-if="!!slots.description"></slot>
            </template>
            <template v-else>
                <div class="z-not-found__title" v-html="text.title"></div>
                <p class="z-not-found__text" v-html="text.description"></p>
            </template>
        </div>
    </div>
</template>

<script setup>
import { localize } from '@/utils/i18n'
import {useSlots} from 'vue'

const props = defineProps({
    hideImage: {
        type: Boolean
    }
})

const image = '/local/templates/z-template/images/znot-found.jpg'
const text = {
    title: localize({
        ru: 'К&nbsp;сожалению, ничего не&nbsp;найдено',
        en: 'No results found',
        cn: '未找到结果'
    }),
    description: localize({
        ru: 'Воспользуйтесь фильтром еще раз или вернитесь на&nbsp;главную страницу',
        en: 'Sorry, no matches were found for your request. Please try to change your query.',
        cn: '抱歉，未找到符合您请求的搜索结果。请尝试更改您的请求。'
    })
}

const slots = useSlots()

defineExpose({
    props
})
</script>

<style lang="scss">
.z-not-found {
    position: relative;
    @include padding-level(top, L);
    @include padding-level(right, XL);
    @include padding-level(bottom, L);
    @include padding-level(left, XL);
    max-width: 100%;
    display: flex;
    align-items: center;
    border-radius: 20px;
    &:before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(0deg, #F2F4FB 0%, #F2F4FB 100%), url(/local/templates/z-template/images/znot-found.jpg) lightgray -376px -438.959px / 179.164% 731.031% no-repeat;
        background-blend-mode: lighten;
        border-radius: 20px;
        opacity: 0.6;
        pointer-events: none;
    }

    @include breakpoint (mobile) {
        flex-direction: column;
        align-items: flex-start;
    }

    &__image {
        flex-shrink: 0;
        margin-right: var(--spacer-2xs);
        z-index: 1;

        @include breakpoint (mobile) {
            margin-right: 0;
            margin-bottom: var(--spacer-xs);
        }
    }

    &__description{
        z-index: 1;
    }

    &__title {
        @include margin-level(bottom, XS);
        display: block;
        @include typo-level(XL);
        color: var(--color-black-90);
        line-height: 1.4;

        @include breakpoint (laptop) {
            font-size: 28px;
        }

        @include breakpoint (mobile) {
            font-size: 26px;
        }
    }

    &__text {
        @include typo-level(M);
        line-height: 1.4;
        color: var(--color-black-80);
        margin-bottom: 0;

        @include breakpoint (mobile) {
            font-size: 16px;
        }
    }
}
</style>
